var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 80167"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 79935",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2174",
    d: "M10.928 3A7.942 7.942 0 113 10.942 7.944 7.944 0 0110.928 3zm0 13.986A6.043 6.043 0 104.9 10.942a6.043 6.043 0 006.028 6.044z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 10",
    d: "M21.038 21.988a.946.946 0 01-.667-.274l-2.442-2.412a.949.949 0 01-.008-1.343.949.949 0 011.343-.008l2.442 2.413a.949.949 0 01-.667 1.625z"
  })))));
}
export default SvgSearch;